// media-library-image/media-library-image-view.js

import { View, Template, LabeledFieldView, createLabeledInputText, ButtonView, submitHandler, InputView } from '@ckeditor/ckeditor5-ui';
import { icons } from '@ckeditor/ckeditor5-core';

export default class FormView extends View {
    constructor( locale ) {
        super( locale );

        this.imagePanelView = this._createImagePanel();
        this.imageFormView = this._createImageForm();

        this.childViews = this.createCollection( [
            this.imagePanelView,
            this.imageFormView
        ] );

        this.setTemplate( {
            tag: 'form',
            attributes: {
                class: [ 'ck', 'ck-media-library-image-wrapper' ],
                tabindex: '-1'
            },
            children: this.childViews
        } );
    }

    render() {
        super.render();

        // Submit the form when the user clicks the save button or presses 'enter' in the input.
        submitHandler( {
            view: this
        } );
    }

    focus() {

    }

    _createImagePanel() {

        const imagePanelView = new View();

        imagePanelView.setTemplate({
            tag: 'div',
            attributes: {
                class: 'ck-media-library-image-panel',
            }
        });

        return imagePanelView;

    }

    _createImageForm() {

        this.altInput = this._createInput('Alt');
        this.widthInput = this._createInput('Width');
        this.imageIdHidden = this._createHidden('imageId');
        this.imageUrlHidden = this._createHidden('imageUrl');
        this.formLoadingHidden = this._createHidden('formLoading');

        this.saveButton = this._createButton( 'Save', icons.check, 'ck-button-save' );
        this.saveButton.type = 'submit';

        this.cancelButton = this._createButton( 'Cancel', icons.cancel, 'ck-button-cancel' );
        this.cancelButton.delegate( 'execute' ).to( this, 'cancel' );

        const uploadIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M212.7 4.688l-144 144c-6.25 6.25-6.25 16.38 0 22.62s16.38 6.25 22.62 0L208 54.63V336c0 8.844 7.156 16 16 16s16-7.156 16-16V54.63l116.7 116.7c6.25 6.25 16.38 6.25 22.62 0s6.25-16.38 0-22.62l-144-144C232.2 1.562 228.1 0 224 0S215.8 1.562 212.7 4.688zM416 336v96c0 26.47-21.53 48-48 48h-288C53.53 480 32 458.5 32 432v-96C32 327.2 24.84 320 16 320S0 327.2 0 336v96C0 476.1 35.88 512 80 512h288c44.13 0 80-35.88 80-80v-96c0-8.844-7.156-16-16-16S416 327.2 416 336z"/></svg>';
        this.uploadButton = this._createButton( 'Upload', uploadIcon, 'ck-button-upload' );
        this.uploadButton.delegate( 'execute' ).to( this, 'upload' );

        const refreshIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M463.5 272.1C463.2 272 462.9 272 462.6 272c-4.031 0-7.469 3-7.938 7.094C443.1 379.9 357.7 456 256 456c-85.8 0-161.6-55.56-188.9-136H184C188.4 320 192 316.4 192 312S188.4 304 184 304H48c-4.406 0-8 3.594-8 8v128C40 444.4 43.59 448 48 448s8-3.594 8-8v-104C88.43 416.9 167.2 472 256 472c109.8 0 202.1-82.16 214.6-191.1C471.1 276.5 467.9 272.6 463.5 272.1zM464 64c-4.406 0-8 3.594-8 8v104C423.6 95.09 344.8 40 256 40c-109.8 0-202.1 82.16-214.6 191.1c-.5 4.375 2.625 8.344 7.031 8.844C48.78 239.1 49.09 240 49.38 240c4.031 0 7.469-3 7.938-7.094C68.91 132.1 154.3 56 256 56c85.8 0 161.6 55.56 188.9 136H328C323.6 192 320 195.6 320 200s3.594 8 8 8h136c4.406 0 8-3.594 8-8v-128C472 67.59 468.4 64 464 64z"/></svg>';
        this.refreshButton = this._createButton( 'Refresh', refreshIcon, 'ck-button-refresh' );
        this.refreshButton.delegate( 'execute' ).to( this, 'refresh' );

        this.imageFormControls = new View();

        this.imageFormControls.setTemplate({
            tag: 'div',
            attributes: {
                class: 'ck-media-library-image-form-controls',
            },
            children: [
                this.saveButton,
                this.cancelButton,
                this.uploadButton,
                this.refreshButton
            ]
        });

        const imageFormView = new View();

        imageFormView.setTemplate({
            tag: 'div',
            attributes: {
                class: 'ck-media-library-image-form',
            },
            children: [
                this.altInput,
                this.widthInput,
                this.imageFormControls,
                this.imageIdHidden,
                this.imageUrlHidden,
                this.formLoadingHidden
            ]
        });

        return imageFormView;
    }

    _createInput( label ) {
        const labeledInput = new LabeledFieldView( this.locale, createLabeledInputText );

        labeledInput.label = label;
        labeledInput.class = label.toLowerCase();

        return labeledInput;
    }

    _createButton( label, icon, className ) {
        const button = new ButtonView();

        button.set( {
            label,
            icon,
            tooltip: true,
            class: className
        } );

        return button;
    }

    _createHidden( label ) {
        const labeledInput = new LabeledFieldView( this.locale, createLabeledInputText );

        labeledInput.class = 'ck-hidden ' + label;

        return labeledInput;
    }

}
